<template>
    <div class="sec">
        <component :is="'jo' + item.name" v-for="item in data" v-bind:key="item.index" v-bind:data="item.data"></component>
    </div>
</template>

<script>
    import jodispformula from '../formula/dispformula.vue'
    import jofig from '../fig/fig.vue'
    import jotable from '../table/table.vue'
    import jofiggroup from '../fig/figgroup.vue'

    export default {
        components: {
          jodispformula,
          jofig,
          jotable,
          jofiggroup
        },
        data() {
            return {

            }
        },
        name: "josec",
        props: [
            'data'
        ],
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/maincontent/body/common/sec.vue